<template>
<standard-dialog v-model="visible" scrollable persistent>

  <template slot="title">
    <span class="title">{{ $t('reactor.new_macro')}}</span>
  </template>

  <v-form ref="form" v-model="validEditor" lazy-validation>
    <gateway-selector v-model="mac" :rules="rulesGateway" :label="$t('reactor.select_gateway')"></gateway-selector>
    <name-text-field v-model="nameText" :rules="rulesName"></name-text-field>
  </v-form>

  <template slot="actions">
    <v-spacer></v-spacer>
    <v-btn :disabled="!validEditor" :loading="creating" flat color="primary" @click="create">{{ $t('reactor.create') }}</v-btn>
  </template>

</standard-dialog>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import Dialog from '@/components/utils/Dialog'
import NameTextField from '@/components/utils/NameTextField'
import GatewaySelector from '@/components/gateway/GatewaySelector'

export default {
  name: 'MacroCreateorDialog',
  mixins: [UserAuth],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'standard-dialog': Dialog,
    'name-text-field': NameTextField,
    'gateway-selector': GatewaySelector
  },
  data() {
    return {
      mac: null,
      creating: false,
      validEditor: false,
      nameText: null,
      rulesName: [
        v => (v && !this.macroNames.includes(v)) || this.$t('reactor.name_should_not_be_duplicated')
      ],
      rulesGateway: [
        v => !!v || this.$t('reactor.gateway_is_required')
      ]
    }
  },
  watch: {
    macros(val) {
      if (this.creating) {
        let macro = val.find(s => s.title == this.nameText);
        if (macro) {
          this.$emit('create', `${this.mac}-${Buffer.from(this.nameText).toString('base64')}`);
          this.visible = false;
        }
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    macros() {
      return this.userMacro[this.mac] || [];
    },
    macroNames() {
      return this.macros.map(s => s.title);
    }
  },
  methods: {
    async create() {
      if (!this.$refs.form.validate()) return;
      this.creating = true;
      let ref = this.$db.ref('command/gateway').push();
      try {
        await ref.set({
          cmd: 'jsonsetall',
          mac: this.mac,
          val: {
            macros: [{
              title: this.nameText
            }]
          }
        });
      } catch (err) {
        this.$emit('toast', this.$t('reactor.permission_denied'));
        this.creating = false;
        return;
      }
      await this.refreshMac(this.mac);
      let refErr = ref.child('error');
      refErr.on('value', snapshot => {
        let val = snapshot.val();
        if (val) {
          ref.remove();
          this.$emit('toast', val);
          this.creating = false;
        }
      });

      setTimeout(() => {
        refErr.off();
      }, 5000);
    }
  },
  mounted() {
    this.$refs.form.reset();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reactor/MacroCreatorDialog.vue